module.exports = __webpack_public_path__ + "img/zonggelu-2.fd76f1d9.jpg";